/* eslint import/no-anonymous-default-export: [2, {'allowArray': true}] */
import React from "react";
import {
  FaThLarge,
  FaBookOpen,
  FaCalendarCheck,
  FaMicrophoneAlt,
  FaMusic,
  FaAward,
  FaSplotch,
  FaWrench,
} from "react-icons/fa";
import { MdBurstMode, MdPeople } from "react-icons/md";
export default [
  {
    id: "1",
    tag: "NavItem",
    name: "Dashboard",
    to: "/dashboard",
    icon: <FaThLarge className="mr-2" />,
  },
  {
    id: ["2", "3", "4"],
    tag: "NavDropdown",
    name: "Banner",
    icon: <MdBurstMode className="mr-2" />,
    children: [
      {
        id: "2",
        tag: "NavItem",
        name: "Spicy club",
        to: "/banner",
      },
      {
        id: "3",
        tag: "NavItem",
        name: "Music",
        to: "/banner-music",
      },
      {
        id: "4",
        tag: "NavItem",
        name: "Home",
        to: "/banner-home",
      },
    ],
  },
  {
    id: ["5", "30", "6"],
    tag: "NavDropdown",
    name: "CMS",
    to: "/cms",
    icon: <FaBookOpen className="mr-2" />,
    children: [
      {
        id: "30",
        tag: "NavItem",
        name: "Contact Us",
        to: "/contact-us",
      },
      {
        id: "5",
        tag: "NavItem",
        name: "News",
        to: "/news",
      },
      {
        id: "6",
        tag: "NavItem",
        name: "Journey",
        to: "/journey",
      },
      {
        id: "7",
        tag: "NavItem",
        name: "Portfolio",
        to: "/portfolio",
      },
    ],
  },
  {
    id: "8",
    tag: "NavItem",
    name: "Events",
    to: "/events",
    icon: <FaCalendarCheck className="mr-2" />,
  },
  {
    id: "10",
    tag: "NavItem",
    name: "Audition",
    to: "/audition",
    icon: <FaMicrophoneAlt className="mr-2" />,
  },
  {
    id: ["11", "9", "29", "12", "13", "14", "15"],
    tag: "NavDropdown",
    name: "Songs",
    to: "/songs",
    icon: <FaMusic className="mr-2" />,
    children: [
      {
        id: "11",
        tag: "NavItem",
        name: "Media",
        to: "/media",
      },
      {
        id: "12",
        tag: "NavItem",
        name: "Genre",
        to: "/genre",
      },
      {
        id: "9",
        tag: "NavItem",
        name: "Artists",
        to: "/artists",
      },
      {
        id: "13",
        tag: "NavItem",
        name: "Songs",
        to: "/songs",
      },
      {
        id: "29",
        tag: "NavItem",
        name: "Albums",
        to: "/albums",
      },
      {
        id: "14",
        tag: "NavItem",
        name: "What's hot",
        to: "/what-hot",
      },
      {
        id: "15",
        tag: "NavItem",
        name: "New release",
        to: "/new-release",
      },
    ],
  },
  {
    id: ["16", "17", "18", "19"],
    tag: "NavDropdown",
    name: "Points",
    to: "/points",
    icon: <FaAward className="mr-2" />,
    children: [
      {
        id: "16",
        tag: "NavItem",
        name: "Voucher",
        to: "/voucher",
      },
      {
        id: "17",
        tag: "NavItem",
        name: "Campaign",
        to: "/campaign",
      },
      {
        id: "18",
        tag: "NavItem",
        name: "Check-in event",
        to: "/check-in-event",
      },
      {
        id: "19",
        tag: "NavItem",
        name: "Adjust points",
        to: "/manual-add",
      },
    ],
  },
  {
    id: "20",
    tag: "NavItem",
    name: "Miles",
    to: "/manual-miles",
    icon: <FaSplotch className="mr-2" />,
  },
  {
    id: "21",
    tag: "NavItem",
    name: "Customers",
    to: "/customer",
    icon: <MdPeople className="mr-2" />,
  },
  {
    id: ["22", "23", "24", "25", "26", "27"],
    tag: "NavDropdown",
    name: "System",
    to: "/system",
    icon: <FaWrench className="mr-2" />,
    children: [
      {
        id: "22",
        tag: "NavItem",
        name: "Users",
        to: "/user",
      },
      {
        id: "23",
        tag: "NavItem",
        name: "User logs",
        to: "/userlog",
      },
      {
        id: "24",
        tag: "NavItem",
        name: "Roles",
        to: "/role",
      },
      {
        id: "26",
        tag: "NavItem",
        name: "Registration Report",
        to: "/register-report",
      },
      {
        id: "25",
        tag: "NavItem",
        name: "Customer Transactions",
        to: "/user-transactions",
      },
      {
        id: "27",
        tag: "NavItem",
        name: "Modules",
        to: "/modules",
      },
    ],
  },
];
